//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  WritableSignal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//local imports
import { CatalogConstants, RoomModel } from '@app/catalog';
import { BreadcrumbChangedMessage, BreadcrumbItemToggleMessage, Messenger, PresenterType } from '@app/shared';



@PresenterType({
  model: RoomModel,
  key: 'tileBottom'
})
@Component({
  selector: 'room-carousel-item-bottom',
  standalone: false,
  templateUrl: './room-carousel-item-bottom.component.html',
  styleUrl: './room-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomCarouselItemBottomComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private selectedRooms = [] 

  public data: WritableSignal<RoomModel> = signal<RoomModel>(undefined);

  constructor(
    private messenger: Messenger
  ){
    this.messenger.subscribe(this, BreadcrumbChangedMessage, (message) => {
        if(message.breadcrumbName !== CatalogConstants.CATALOG) { 
            return;
        }
        message.breadcrumbs.forEach((item) => {
          const exists = this.selectedRooms.some(room => room.id === item.id);
          if (!exists) {
            this.selectedRooms.push(item);
          }
        })
    });
  }

 public navigateToDetailPage() {
    const currentRoom = this.data();
    
    const isAlreadySelected = this.selectedRooms.some(room => room.id === currentRoom.id);
    
    if (!isAlreadySelected) {
      this.messenger.send(new BreadcrumbItemToggleMessage(currentRoom, CatalogConstants.CATALOG));
    }
    
    this.router.navigate(["room", currentRoom.id], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
    });
  }
}
